import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f0842e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-search el-input__icon fas" }, null, -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode("+")
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("+")
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("+")
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["title"]
const _hoisted_9 = ["title"]
const _hoisted_10 = ["title"]
const _hoisted_11 = ["title"]
const _hoisted_12 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_page_header_component = _resolveComponent("page-header-component")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_user_form_component = _resolveComponent("user-form-component")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, null, {
      header: _withCtx(() => [
        _createVNode(_component_page_header_component, {
          title: _ctx.$t('label.userList')
        }, {
          right: _withCtx(() => [
            _createVNode(_component_el_input, {
              class: "search",
              modelValue: _ctx.searchedUser,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchedUser) = $event)),
              placeholder: _ctx.$t('placeholder.search'),
              onKeyup: _cache[1] || (_cache[1] = ($event: any) => (_ctx.refreshUser()))
            }, {
              prefix: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["title"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: _ctx.users,
          stripe: "",
          "row-class-name": _ctx.tableRowClassName,
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "name",
              fixed: "left",
              label: _ctx.$t('label.name'),
              width: "130"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("span", {
                  style: _normalizeStyle({ fontWeight: row.aquacorpMember === 'Member' ? 'bold' : 'normal' })
                }, _toDisplayString(row.name), 5)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "email",
              label: "Email",
              width: "180",
              align: "center",
              "header-align": "center"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("span", {
                  class: _normalizeClass({ 'bold-text': row.aquacorpMember === 'Member' })
                }, _toDisplayString(row.email || "-"), 3)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "permissions",
              label: "Roles",
              "min-width": "180",
              width: "270",
              align: "center",
              "header-align": "center"
            }, {
              default: _withCtx((scope) => [
                (scope.row.permissions && Object.keys(scope.row.permissions).length)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.convertObjectToArray(
                scope.row.permissions,
                'permissions'
              ).slice(0, 3), (station, id) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: station }, [
                        (id < 2)
                          ? (_openBlock(), _createBlock(_component_el_tag, {
                              key: 0,
                              class: "ml-1"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(station.name), 1)
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true),
                        (id === 2)
                          ? (_openBlock(), _createBlock(_component_el_tooltip, {
                              key: 1,
                              visible: _ctx.visible,
                              "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.visible) = $event))
                            }, {
                              content: _withCtx(() => [
                                _createElementVNode("span", null, _toDisplayString(_ctx.getListNameObject(scope.row.permissions)), 1)
                              ]),
                              default: _withCtx(() => [
                                (id === 2)
                                  ? (_openBlock(), _createBlock(_component_el_tag, {
                                      key: 0,
                                      class: "ml-1",
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_2
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1032, ["visible"]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  : (_openBlock(), _createElementBlock("span", _hoisted_3, "-"))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "stations",
              label: _ctx.$t('menu.stations'),
              width: "180",
              align: "center",
              "header-align": "center"
            }, {
              default: _withCtx((scope) => [
                (scope.row.stations && Object.keys(scope.row.stations).length)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.convertObjectToArray(scope.row.stations, 'stations').slice(
                0,
                3
              ), (station, id) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: station }, [
                        (id < 2)
                          ? (_openBlock(), _createBlock(_component_el_tag, {
                              key: 0,
                              class: "ml-1",
                              type: "info",
                              effect: "plain"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(station.name), 1)
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true),
                        (id === 2)
                          ? (_openBlock(), _createBlock(_component_el_tooltip, {
                              key: 1,
                              visible: _ctx.visible,
                              "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.visible) = $event))
                            }, {
                              content: _withCtx(() => [
                                _createElementVNode("span", null, _toDisplayString(_ctx.getListNameObject(scope.row.stations)), 1)
                              ]),
                              default: _withCtx(() => [
                                (id === 2)
                                  ? (_openBlock(), _createBlock(_component_el_tag, {
                                      key: 0,
                                      class: "ml-1",
                                      type: "info",
                                      size: "small",
                                      effect: "plain"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_4
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1032, ["visible"]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  : (_openBlock(), _createElementBlock("span", _hoisted_5, "-"))
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "samplingPoints",
              label: _ctx.$t('menu.samplingPoints'),
              align: "center",
              "header-align": "center"
            }, {
              default: _withCtx((scope) => [
                (scope.row.samplingPoints && Object.keys(scope.row.samplingPoints).length)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.convertObjectToArray(
                scope.row.samplingPoints,
                'samplingPoints'
              ), (sampoint, id) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: sampoint }, [
                        (id < 2)
                          ? (_openBlock(), _createBlock(_component_el_tag, {
                              key: 0,
                              class: "ml-1",
                              type: "info",
                              effect: "plain"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(sampoint.name), 1)
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true),
                        (id === 2)
                          ? (_openBlock(), _createBlock(_component_el_tooltip, {
                              key: 1,
                              visible: _ctx.visible,
                              "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.visible) = $event))
                            }, {
                              content: _withCtx(() => [
                                _createElementVNode("span", null, _toDisplayString(_ctx.getListNameObject(scope.row.samplingPoints)), 1)
                              ]),
                              default: _withCtx(() => [
                                (id === 2)
                                  ? (_openBlock(), _createBlock(_component_el_tag, {
                                      key: 0,
                                      class: "ml-1",
                                      type: "info",
                                      size: "small",
                                      effect: "plain"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_6
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1032, ["visible"]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  : (_openBlock(), _createElementBlock("span", _hoisted_7, "-"))
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "active",
              label: _ctx.$t('label.status'),
              align: "center",
              width: "90"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_tag, {
                  type: scope.row.active ? 'success' : 'danger'
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(scope.row.active ? "status.active" : "status.no-active")), 1)
                  ]),
                  _: 2
                }, 1032, ["type"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              label: _ctx.$t('label.operations'),
              align: "center"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_button, {
                  type: "default",
                  size: "small",
                  onClick: ($event: any) => (_ctx.openUserFormDialog(scope.row))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("em", {
                      class: "el-icon el-icon-edit fas",
                      title: _ctx.$t('btn.edit')
                    }, null, 8, _hoisted_8)
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                (!scope.row.active)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "success",
                      size: "small",
                      onClick: ($event: any) => (_ctx.confirmActivateItem(scope.row))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("em", {
                          class: "el-icon el-icon-check fas",
                          title: _ctx.$t('btn.activate')
                        }, null, 8, _hoisted_9)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                (scope.row.active)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      type: "danger",
                      size: "small",
                      color: "orange",
                      onClick: ($event: any) => (_ctx.confirmDeactivateItem(scope.row))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("em", {
                          class: "el-icon el-icon-times fas",
                          title: _ctx.$t('btn.deactivate')
                        }, null, 8, _hoisted_10)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_button, {
                  size: "small",
                  onClick: ($event: any) => (_ctx.confirmDeleteUser(scope.row)),
                  color: "red",
                  disabled: scope.row.aquacorpMember != 'Member'
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("em", {
                      class: "el-icon el-icon-trash fas",
                      title: _ctx.$t('btn.delete')
                    }, null, 8, _hoisted_11)
                  ]),
                  _: 2
                }, 1032, ["onClick", "disabled"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["data", "row-class-name"]),
        _createVNode(_component_el_pagination, {
          class: "app-table",
          layout: "total, sizes, prev, pager, next, jumper",
          currentPage: _ctx.currentPage,
          "onUpdate:currentPage": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.currentPage) = $event)),
          "page-sizes": [10, 20, 50, 100],
          "page-size": _ctx.rowPerPage,
          total: _ctx.totalRows,
          onSizeChange: _ctx.onSizeChange,
          onCurrentChange: _ctx.onCurrentChange,
          style: {"width":"100%"}
        }, null, 8, ["currentPage", "page-size", "total", "onSizeChange", "onCurrentChange"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.showUserForm,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.showUserForm) = $event)),
      title: _ctx.$t(_ctx.userSelected?.id ? 'label.userEdit' : 'label.userNew'),
      width: "50%",
      "destroy-on-close": "",
      "custom-class": "app-form"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_12, [
          _createVNode(_component_el_button, {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.closeUserFormDialog()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("btn.cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.modifyUser()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("btn.modify")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_user_form_component, {
          ref: "userForm",
          id: _ctx.userSelected.id
        }, null, 8, ["id"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}